import React, { Fragment, useState, useEffect } from "react";
import HeaderComponent from "../../components/HeaderComponent";
import TitleH2Component from "../../components/TitleH2Component";
import InputComponent from "../../components/InputComponent";
import stylebtn from "../../styles/btn.module.scss";
import { Icon } from "@iconify/react/dist/iconify.js";
import ParrafoComponent from "../../components/ParrafoComponent";
import ModalGeneralComponent from "../../components/ModalGeneralComponent";
import styleform from "../../styles/form.module.scss";
import LoaderComponent from "../../components/LoaderComponent";
import AlertComponent from "../../components/AlertComponent";
import MoneyInputComponent from "../../components/MoneyInputComponent";
import TitleH4Component from "../../components/TitleH4Component";

import {
  BuscarCliente,
  PostCliente,
  PostventaRapida,
  postventaRapidaDetalle,
} from "../../api/ApiVenta";
import { EditarPersona, PostPersona } from "../../api/Empleado";
import { useAuth } from "../../context/AuthContext";
import TextAreaComponent from "../../components/TextAreaComponent";

const ElaboracionMaderaPage = () => {
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [alert, setAlert] = useState(false);
  const [mensajealerta, setMensajealerta] = useState("");
  const [ventaR, setventaR] = useState([]);
  const [showventa, setShowVenta] = useState(false);
  const [idfactura, serIdfactura] = useState(null);
  const [currentPersona, setCurrentPersona] = useState([]);
  const [idCliente, setIdCliente] = useState("");
  const [currentCliente, setCurrentCliente] = useState([]);
  const [control, setControl] = useState(false);
  const { idUser } = useAuth();

  const [formData, setFormData] = useState({
    cantidad: "",
    elaboracionMadera: "",
    descripcion: "",
  });

  const [formDataCliente, setFormDataCliente] = useState({
    id_user: idUser,
    fecha_vencimiento: null,
    nombre: "",
    cedula: "",
    direccion: "",
    telefono: "",
    quien_recibe: "",
  });

  const [formDataPersona, setFormDataPersona] = useState({
    cedula: "",
    nombre: "",
    apellido: "",
    direccion: "",
    celular: "",
  });

  const handleCloseVenta = () => {
    setShowVenta(false);
  };

  // Manejar el cambio en el input
  const handleInputChangePersona = (event) => {
    const { name, value } = event.target;
    setFormDataPersona({
      ...formDataPersona,
      [name]: value,
    });
  };

  // Manejar el cambio en el input
  const handleInputChangeCliente = (e) => {
    const { name, value } = e.target;
    setFormDataCliente((prev) => ({
      ...prev,
      [name]: name === "total_pagado" ? Number(value) : value, //
    }));
  };

  // Manejar el cambio en el input
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // este es el metodo para sacar el valor del check
  const handleCheckboxChange = (event) => {
    const { id, checked } = event.target;
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [id]: checked,
    }));
  };

  const [checkboxes, setCheckboxes] = useState({
    isChecked: false,
    debeActualizarCliente: false,
  });

  useEffect(() => {
    const ventaActual = JSON.parse(localStorage.getItem("ventaRapida")) || [];
    setventaR(ventaActual);
  }, []);

  // metodo para verificar el cliente antes de registrar la compra
  const verificarCliente = async (e) => {
    e.preventDefault();
    const cedula = formDataPersona.cedula?.trim();
    if (!cedula) {
      setMensaje("Por favor ingrese una cédula válida");
      setTimeout(() => setMensaje(""), 3000);
      return;
    }

    try {
      setLoading(true);
      const res = await BuscarCliente(cedula);
      setControl(res?.success);
      if (res?.success && res.data) {
        const cliente = res.data;

        // ✅ Actualiza los datos del cliente encontrado
        setFormDataPersona((prev) => ({
          ...prev,
          cedula: cliente.cedula || cedula,
          nombre: cliente.nombre || "",
          apellido: cliente.apellido || "",
          direccion: cliente.direccion || "",
          celular: cliente.celular || "",
        }));

        // ✅ Guarda info adicional
        setCurrentPersona(cliente);
        setIdCliente(cliente.Clientes?.[0]?.id || "");
        setCurrentCliente(cliente.Clientes || []);

        setMensaje("Cliente encontrado ✅");
      } else {
        // 🚫 Cliente no existe
        setIdCliente("");
        setCurrentPersona([]);
        setCurrentCliente([]);
        setFormDataPersona((prev) => ({
          ...prev,
          nombre: "",
          apellido: "",
          direccion: "",
          celular: "",
        }));

        setMensaje("El cliente no existe ❌");
      }
    } catch (error) {
      console.error("Error verificando cliente:", error);
      setMensaje("Error al verificar el cliente");
    } finally {
      setLoading(false);
      setTimeout(() => setMensaje(""), 3000);
    }
  };

  const crearCliente = async (debeActualizar = false) => {
    if (!control || control === false) {
      const resP = await PostPersona(formDataPersona);
      if (resP.success) {
        const rescliente = await PostCliente(resP.data.idP);
        setIdCliente(rescliente?.data?.id);
        return rescliente?.data?.id;
      }
      // La cédula ya existe pero no se verificó — buscarla y reutilizarla
      const existing = await BuscarCliente(formDataPersona.cedula);
      if (existing?.success && existing.data) {
        setControl(true);
        setCurrentPersona(existing.data);
        setCurrentCliente(existing.data.Clientes || []);
        const existingId = existing.data.Clientes?.[0]?.id;
        if (existingId) {
          setIdCliente(existingId);
          return existingId;
        }
        const rescliente = await PostCliente(existing.data.idP);
        setIdCliente(rescliente?.data?.id);
        return rescliente?.data?.id;
      }
    } else if (currentCliente.length === 0) {
      const rescliente = await PostCliente(currentPersona?.idP);
      setIdCliente(rescliente?.data?.id);
      if (debeActualizar) {
        await EditarPersona(currentPersona?.idP, formDataPersona);
      }
      return rescliente?.data?.id; // ✅ devolvemos el ID
    } else {
      // Si ya existe cliente actual, devolvemos su ID directamente
      if (debeActualizar) {
        await EditarPersona(currentPersona?.idP, formDataPersona);
      }
      return currentCliente[0]?.id;
    }
  };

  const crearVentaRapida = async () => {
    try {
      // Validaciones
      if (!formData.cantidad || !formData.elaboracionMadera) {
        setMensaje("Cantidad y precio son obligatorios");
        setTimeout(() => setMensaje(""), 3000);
        return;
      }

      if (
        !formDataPersona.nombre ||
        !formDataPersona.cedula ||
        !formDataPersona.apellido
      ) {
        setMensaje("El campo nombre, apellido y cédula son obligatorios");
        setTimeout(() => setMensaje(""), 3000);
        return;
      }

      setLoading(true);

      // ✅ 1. Crear o verificar cliente
      const clienteId = await crearCliente(checkboxes.debeActualizarCliente);

      // ✅ 3. Preparar datos de la venta rápida
      const dataVentaRapida = {
        id_user: idUser,
        id_cliente: clienteId,
        nombre: formDataPersona.nombre,
        cedula: formDataPersona.cedula,
        direccion: formDataPersona.direccion,
        telefono: formDataPersona.celular,
        quien_recibe: formDataCliente.quien_recibe,
        fecha_vencimiento: null,
        total: formData?.elaboracionMadera,
        total_pagado: 0,
        descuento: 0,
        transporte: 0,
        estado: "0",
        tipo: "elaboracion",
        elaboracionMadera: formData?.elaboracionMadera,
        descripcionElaboracion: formData?.descripcion,
      };

      // ✅ 4. Crear la venta rápida
      const ventaRapida = await PostventaRapida(dataVentaRapida);

      if (ventaRapida.res?.success) {
        const idVenta = ventaRapida.res.data.id;

        // ✅ 5. Crear detalle (producto virtual de elaboración)
        const detalleElaboracion = [
          {
            producto: formData?.descripcion || "Elaboración de madera",
            cantidad: formData?.cantidad,
            precioUnidad: formData?.elaboracionMadera,
            subtotal: formData?.elaboracionMadera,
            pendiente_entrega: formData?.elaboracionMadera,
          },
        ];

        const detalle = await postventaRapidaDetalle(
          ventaRapida?.res?.data?.id,
          detalleElaboracion,
        );

        console.log("Detalle de elaboracion", detalle);

        if (detalle?.status === 201) {
          serIdfactura(idVenta);
          setMensajealerta("✅ Elaboración registrada correctamente");
          setAlert(true);
          setShowVenta(true);

          // ✅ Limpiar formulario
          setFormData({
            cantidad: "",
            elaboracionMadera: "",
            descripcion: "",
          });

          setFormDataPersona({
            cedula: "",
            nombre: "",
            apellido: "",
            direccion: "",
            celular: "",
          });

          setFormDataCliente({
            id_user: idUser,
            fecha_vencimiento: null,
            nombre: "",
            cedula: "",
            direccion: "",
            telefono: "",
            quien_recibe: "",
            tipo: "elaboracion",
          });
        }
      }
    } catch (error) {
      console.error("❌ Error creando elaboración:", error);
      setMensaje("Error al registrar la elaboración");
      setTimeout(() => setMensaje(""), 3000);
    } finally {
      setLoading(false);
    }
  };


  const verificarfactura = () => {
    window.location.href = `/generarfacturaventaR/${idfactura}`;
  };

  return (
    <Fragment>
      <HeaderComponent styleGroup="">
        <TitleH2Component styleGroup="box-text color-dark fw700 roboto mb-4">
          ELABORACION DE MADERA
        </TitleH2Component>
      </HeaderComponent>

      <div className="conatiner-global pt-3 pb-5">
        <section className="mb-3 border border-dark rounded p-3">
          <form action="" onSubmit={verificarCliente}>
            <div className="container">
              <TitleH4Component styleGroup="box-text color-madera text-center fw700 roboto mb-1">
                INFORMACION DEL COMPRADOR
              </TitleH4Component>
              <div
                className={`${styleform.checkbox} d-flex justify-content-start mb-2`}
              >
                <input
                  className=" me-2"
                  type="checkbox"
                  value=""
                  id="debeActualizarCliente"
                  checked={checkboxes.debeActualizarCliente}
                  onChange={handleCheckboxChange}
                />
                <label className="color-madera fw700" htmlFor="recorddat">
                  Actualizar información cliente
                </label>
              </div>

              <div className="row gy-4 d-flex  align-items-center mb-4">
                {/**d-flex justify-content-end align-items-end*/}
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Documento"
                    styleLabel="fw600 WorkSans"
                    styleGroup="me-2"
                    htmlFor="bloque"
                    type="text"
                    placeholder="Documento"
                    value={formDataPersona.cedula}
                    name="cedula"
                    onChange={handleInputChangePersona}
                    //onKeyDown={handleKeyDown}
                  />
                  {!alert && (
                    <ParrafoComponent styleGroup="mt-2 color-danger fw400 WorkSans">
                      {mensaje}
                    </ParrafoComponent>
                  )}
                </div>

                <div className="col-12 col-md-6 col-xl-3">
                  <button
                    type="submit"
                    className={` btn ${stylebtn.btn} ${stylebtn.primary} ms-3`}
                  >
                    Verificar Cliente
                  </button>
                </div>
              </div>
              <div className="row gy-4">
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Nombre"
                    styleLabel="fw600 WorkSans"
                    styleGroup="me-2"
                    htmlFor="bloque"
                    type="text"
                    placeholder="Ingrese Nombre"
                    value={formDataPersona.nombre}
                    name="nombre"
                    onChange={handleInputChangePersona}
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Apellido"
                    styleLabel="fw600 WorkSans"
                    styleGroup="me-2"
                    htmlFor="bloque"
                    type="text"
                    placeholder="Ingrese Apellido"
                    value={formDataPersona.apellido}
                    name="apellido"
                    onChange={handleInputChangePersona}
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Telefono"
                    styleLabel="fw600 WorkSans"
                    styleGroup="me-2"
                    htmlFor="bloque"
                    placeholder="Ingresar telefono"
                    type="text"
                    value={formDataPersona.celular}
                    name="celular"
                    onChange={handleInputChangePersona}
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Direccion"
                    styleLabel="fw600 WorkSans"
                    styleGroup="me-2"
                    htmlFor="bloque"
                    placeholder="Ingresar dirección"
                    type="text"
                    name="direccion"
                    value={formDataPersona.direccion}
                    onChange={handleInputChangePersona}
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Quien Recibe"
                    styleLabel="fw600 WorkSans"
                    styleGroup="me-2"
                    htmlFor="bloque"
                    type="text"
                    placeholder="Recibido"
                    value={formDataCliente.quien_recibe}
                    name="quien_recibe"
                    onChange={handleInputChangeCliente}
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Direccion de envio"
                    styleLabel="fw600 WorkSans"
                    styleGroup="me-2"
                    htmlFor="bloque"
                    type="text"
                    placeholder="Direccion"
                    value={formDataCliente.direccion}
                    name="direccion"
                    onChange={handleInputChangeCliente}
                  />
                </div>
              </div>
            </div>
          </form>
        </section>
        <div className="container-fluid border border-dark rounded p-2">
          <form action="" className="mt-3">
            <TitleH4Component styleGroup="box-text color-madera text-center fw700 roboto mb-4">
              Detalle de elaboracon de producto(s)
            </TitleH4Component>
            <div className="row gy-4">
              {" "}
              <div className="row d-flex align-items-center">
                <div className="col-12 col-sm-6 col-lg-2">
                  <InputComponent
                    label="Cantidad"
                    placeholder="0"
                    styleLabel="fw600 WorkSans"
                    styleGroup=" mb-2"
                    htmlFor="bloque"
                    type="number"
                    name="cantidad"
                    value={formData.cantidad}
                    onChange={handleInputChange}
                    //width="100px"
                  />
                </div>
                <div className="col-12 col-sm-6 col-lg-3">
                  <MoneyInputComponent
                    label="Precio"
                    placeholder="Ingerse precio"
                    styleLabel="fw600 WorkSans"
                    styleGroup=" mb-2"
                    //styleGroup={`${stylegeneral.col}`}
                    type="number"
                    value={formData.elaboracionMadera}
                    name="elaboracionMadera"
                    onChange={handleInputChange}
                  />
                </div>

                <div className="col-12">
                  <TextAreaComponent
                    label="Descripción"
                    placeholder="Ingrese descripción detallada del producto"
                    styleLabel="fw600 WorkSans"
                    styleGroup="mb-2"
                    name="descripcion"
                    value={formData.descripcion}
                    onChange={handleInputChange}
                    rows={4}
                  />
                </div>
                <div className="col-12 d-flex justify-content-center">
                  <button
                    type="button"
                    className={`${stylebtn.btn} ${stylebtn.primary}  mt-4`}
                    onClick={crearVentaRapida}
                  >
                    Despachar
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/** modal ingresar informacion del cliente **/}
      <section>
        <ModalGeneralComponent
          ModalHeader={false}
          titulo="Información del cliente"
          styleGroup={`d-flex align-items-center modal-general `}
          styleBody={`${"bg-gris-modal "}`}
          styleTitle={"box-text color-madera fw700 roboto text-center WorkSans"}
          show={showventa}
          handleClose={handleCloseVenta}
        >
          {loading ? (
            <LoaderComponent styleGroup="mt-5" />
          ) : (
            <div>
              <div className="d-flex justify-content-end mb-0 align-items-center mb-3">
                <button
                  type="button"
                  onClick={verificarfactura}
                  className={`btn ${stylebtn.btn} ${stylebtn.primary} me-3`}
                >
                  Generar factura
                </button>
                <button
                  type="button"
                  className={`btn ${stylebtn.btn_desnudo} ${stylebtn.icon} p-0 d-inline-flex`}
                  onClick={handleCloseVenta}
                >
                  <Icon icon="mdi:close-thick" />
                </button>
              </div>
              <TitleH2Component styleGroup="box-text color-soccess fw700 roboto mb-0 text-center WorkSans">
                {mensajealerta}
              </TitleH2Component>
            </div>
          )}
        </ModalGeneralComponent>
      </section>
    </Fragment>
  );
};

export default ElaboracionMaderaPage;
